import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SteppIndicatorComponent } from '@core/components/stepp-indicator/stepp-indicator.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [
        SteppIndicatorComponent
    ],
    imports     : [
        CommonModule,
        MatIconModule
    ],
    exports     : [
        SteppIndicatorComponent
    ]
})
export class SteppIndicatorModule
{
}
